import React, { useState, useEffect } from "react";
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faHome, 
  faMicroscope, 
  faFlask, 
  faLeaf,
  faEnvelope, 
  faInfoCircle,
  faBars,
  faTimes,
  faChevronDown,
  faPhone,
  faUserMd
} from "@fortawesome/free-solid-svg-icons";
import logo from "../Assets/epweb.png";
import "../Styles/Headerstyle.css";

function Header() {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  // Close mobile menu on route change
  useEffect(() => {
    setExpanded(false);
    setDropdownOpen(false);
  }, [location]);

  const handleLinkClick = () => {
    setExpanded(false);
    setDropdownOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const productLinks = [
    { path: "/HAIRREMOVAL", label: "Hair Removal",  },
    { path: "/aiskin", label: "AI Skin Analyzer", },
    { path: "/co2", label: "CO2 Laser",  },
    { path: "/revive", label: "IPL Revive", },
    { path: "/thermilif", label: "Thermilif HIFU",  },
    { path: "/rf", label: "ThermiQ RF", },
    { path: "/pictron11", label: "Pictron11", },
  ];

  return (
    <>
      {/* Top Bar - Hidden on mobile */}
      <div className="top-bar">
        <Container>
          <div className="top-bar-content">
            <div className="top-bar-left">
              <span className="top-bar-item">
                <FontAwesomeIcon icon={faPhone} className="top-bar-icon" />
                +964 774 405 2020
              </span>
              <span className="top-bar-item">
                <FontAwesomeIcon icon={faUserMd} className="top-bar-icon" />
                Medical Grade Devices
              </span>
            </div>
            <div className="top-bar-right">
              <span className="top-bar-badge">CE Certified</span>
              <span className="top-bar-badge">ISO 13485</span>
            </div>
          </div>
        </Container>
      </div>

      {/* Main Header */}
      <Navbar 
        expand="lg"
        expanded={expanded}
        onToggle={(isExpanded) => setExpanded(isExpanded)}
        className={`main-header ${scrolled ? 'header-scrolled' : ''}`}
        fixed="top"
      >
        <Container>
          {/* Logo */}
          <NavLink to="/" className="navbar-brand" onClick={handleLinkClick}>
            <div className="logo-container">
              <img 
                src={logo} 
                alt="Epilyum" 
                className="logo-image"
              />
              <div className="logo-glow"></div>
            </div>
          </NavLink>

          {/* Mobile Toggle with Animation */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler">
            <div className={`toggler-icon ${expanded ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </Navbar.Toggle>

          {/* Navigation Menu */}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {/* Home */}
              <NavLink 
                to="/" 
                className={({ isActive }) => 
                  `nav-link-custom ${isActive ? 'active' : ''}`
                }
                onClick={handleLinkClick}
              >
                <FontAwesomeIcon icon={faHome} className="nav-icon" />
                <span className="nav-label">Home</span>
                <span className="nav-hover-effect"></span>
              </NavLink>

              {/* Devices Dropdown */}
              <div className="nav-dropdown-custom">
                <div 
                  className={`dropdown-trigger ${dropdownOpen ? 'open' : ''}`}
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <FontAwesomeIcon icon={faMicroscope} className="nav-icon" />
                  <span className="nav-label">Devices</span>
                  <FontAwesomeIcon 
                    icon={faChevronDown} 
                    className={`dropdown-arrow ${dropdownOpen ? 'rotate' : ''}`}
                  />
                </div>
                
                <div className={`dropdown-menu-custom ${dropdownOpen ? 'show' : ''}`}>
                  {productLinks.map((link) => (
                    <NavLink
                      key={link.path}
                      to={link.path}
                      className={({ isActive }) => 
                        `dropdown-item-custom ${isActive ? 'active' : ''}`
                      }
                      onClick={handleLinkClick}
                    >
                      <span className="dropdown-item-icon">{link.icon}</span>
                      <span className="dropdown-item-label">{link.label}</span>
                      <span className="dropdown-item-arrow">→</span>
                    </NavLink>
                  ))}
                </div>
              </div>

              {/* Cicalfate */}
              <NavLink 
                to="/cicalfate"
                className={({ isActive }) => 
                  `nav-link-custom ${isActive ? 'active' : ''}`
                }
                onClick={handleLinkClick}
              >
                <FontAwesomeIcon icon={faLeaf} className="nav-icon" />
                <span className="nav-label">Cicalfate+</span>
                <span className="nav-hover-effect"></span>
              </NavLink>

              {/* Contact Us */}
              <NavLink 
                to="/contact-us"
                className={({ isActive }) => 
                  `nav-link-custom ${isActive ? 'active' : ''}`
                }
                onClick={handleLinkClick}
              >
                <FontAwesomeIcon icon={faEnvelope} className="nav-icon" />
                <span className="nav-label">Contact</span>
                <span className="nav-hover-effect"></span>
              </NavLink>

              {/* About Us */}
              <NavLink 
                to="/about-us"
                className={({ isActive }) => 
                  `nav-link-custom ${isActive ? 'active' : ''}`
                }
                onClick={handleLinkClick}
              >
                <FontAwesomeIcon icon={faInfoCircle} className="nav-icon" />
                <span className="nav-label">About</span>
                <span className="nav-hover-effect"></span>
              </NavLink>
            </Nav>

            {/* Mobile Bottom Bar */}
            <div className="mobile-bottom-bar">
              <div className="mobile-contact">
                <FontAwesomeIcon icon={faPhone} />
                <a href="tel:+9647744052020">+964 774 405 2020</a>
              </div>
              <div className="mobile-badges">
                <span>CE Certified</span>
                <span>ISO 13485</span>
              </div>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Spacer for fixed header */}
      <div className="header-spacer"></div>
    </>
  );
}

export default Header;